import {
  saveNlpRequests,
  updateTrainedNlpRequest,
} from '../actions/nlpRequests'
import {
  addIntent,
  deleteOldIntent,
  saveIntents,
  updateExistedIntent,
} from '../actions/intents'
import {
  saveIntentsSize,
  deleteOldIntentsSize,
} from '../actions/intentsSize'
import {
  alertError,
  alertSuccess,
  createJsonHeaders,
  logoutOnRequestOrResponseJson,
} from '../../../api/'
import { BASE_URL } from '../../../configs'
import api from '../../../services/api'

export function getIntents(botId, faq) {
  fetch(BASE_URL + '/intent/bot/' + botId + '/faq/' + faq, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'GET',
  })
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          saveIntents(json)
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError(
        'Sorry but something going wrong at getting intents please ping support!',
      )
    })
}

export function getPagingIntents(botId, faq, page, query) {
  return fetch(
    BASE_URL +
      '/intent/bot/' +
      botId +
      '/faq/' +
      faq +
      '/' +
      page +
      '/search?query=' +
      query,
    {
      credentials: 'include',
      headers: createJsonHeaders(),
      method: 'GET',
    },
  )
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          saveIntentsSize(json.intentsSize)
          saveIntents(json.intentDTOList)
          return json.intentDTOList
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError(
        'Sorry but something going wrong at getting intents please ping support!',
      )
    })
}

export function getAllPagingIntents(botId, query = '') {
  fetch(BASE_URL + '/intent/bot/' + botId + '?query=' + query, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'GET',
  })
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          saveIntents(json)
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError(
        'Sorry but something going wrong at getting intents please ping support!',
      )
    })
}

export function getAllPagingIntentsForTriggers(botId, query) {
  fetch(
    BASE_URL + '/intent/bot/' + botId + '?includeFAQ=false&query=' + query,
    {
      credentials: 'include',
      headers: createJsonHeaders(),
      method: 'GET',
    },
  )
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          saveIntents(json)
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError(
        'Sorry but something going wrong at getting intents please ping support!',
      )
    })
}

export function getAllIntents(botId) {
  fetch(BASE_URL + '/intent/bot/' + botId, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'GET',
  })
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          saveIntents(json)
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError(
        'Sorry but something going wrong at getting intents please ping support!',
      )
    })
}

export function getTrainingData(botId, page, size, shortName) {
  fetch(
    BASE_URL +
      '/bot/' +
      botId +
      '/training' +
      '?page=' +
      page +
      '&size=' +
      size +
      '&shortName=' +
      shortName,
    {
      credentials: 'include',
      headers: createJsonHeaders(),
      method: 'GET',
    },
  )
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          saveNlpRequests(json)
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError(
        'Sorry but something going wrong at getting triggers please ping support!',
        5000,
      )
    })
}

export function getHistoryData(botId, page, size, shortName) {
  fetch(
    `${BASE_URL}/bot/${botId}/training/all?page=${page}&size=${size}&shortName=${shortName}`,
    {
      credentials: 'include',
      headers: createJsonHeaders(),
      method: 'GET',
    },
  )
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          saveNlpRequests(json)
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError(
        'Sorry but something going wrong at getting training data please ping support!',
      )
    })
}

export function getIntentUserSays(intentId) {
  return fetch(BASE_URL + '/intent/' + intentId, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'GET',
  })
    .then(response => {
      if (response.status === 400) {
        response.text().then(text => alertSuccess(text))
        return
      }
      return logoutOnRequestOrResponseJson(response)
    })
    .catch(function(error) {
      alertError(
        'Sorry but something going wrong at getting intent please ping support!',
      )
    })
}

export function createNewIntent(intent) {
  return fetch(BASE_URL + '/intent', {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'POST',
    body: JSON.stringify(intent),
  })
    .then(response => {
      if (!response.ok) {
        throw response.json()
      }
      return logoutOnRequestOrResponseJson(response)
    })
    .then(json => {
      alertSuccess('Intent is created successfully.')
      addIntent(json)
      return json
    })
    .catch(function(error) {
      alertError(`Create intent error: ${error?.message}`, 10000)
    })
}

export function trainIntent(request, botId) {
  return fetch(BASE_URL + '/bot/' + botId + '/nlpRequest/train', {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'POST',
    body: JSON.stringify(request),
  })
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          updateTrainedNlpRequest(json.data)
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError('Fail. Try it later')
    })
}

export function updateIntent(intent, callback) {
  return fetch(BASE_URL + '/intent', {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'PUT',
    body: JSON.stringify(intent),
  })
    .then(response => {
      if (response.status === 200) {
        return logoutOnRequestOrResponseJson(response).then(json => {
          alertSuccess('Intent is updated successfully.')
          updateExistedIntent(json)
        })
      }
      response.text().then(text => alertSuccess(text))
    })
    .catch(function(error) {
      alertError('Fail. Try it later')
    })
}

export function deleteIntent(intentId, intentsSize) {
  api.delete(`${BASE_URL}/intent/${intentId}`)
    .then(() => {
      alertSuccess('Intent is deleted successfully.')
      deleteOldIntent(intentId)
      deleteOldIntentsSize(intentsSize)
    })
    .catch(() => {
      alertError('Sorry but something going wrong at getting training data please ping support!')
    })
}
